import { Button, Grid, TextField } from '@mui/material'
import React, { useState } from 'react'
import { Create } from 'react-admin'
import AppConstantService from '../../services/AppConstantService';
import EventBus from '../../EventBus';
import { EventBusEventsEnum } from '../../enums/EventBusEventsEnum';
import { CustomSnackbarTypes } from '../Common/CustomSnackBar';
import {useNavigate} from "react-router-dom";

let appConstantService = new AppConstantService(); 
function CreateAppConstant() {
    let navigate = useNavigate();
    let [name, setName] = useState<string>('');
    let [value, setValue] = useState<string>('');

    const handleSave = () => {
    if (!name || !value) {
        alert("Name and Value cannot be empty");
        return;
    }
    const payload = {
        name: name,
        value: value
    }; 

    appConstantService.createAppConstant(payload).then((response: any) => {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Created Successfully",
            type: CustomSnackbarTypes.SUCCESS,
        });
        setName('');
        setValue('');
        navigate(`/AppConstants/${response?.id}/show`, {replace: true})
    }).catch((error: any) => {
        console.error("Error creating App Constant:", error);
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            type: CustomSnackbarTypes.ERROR,
        });
    });
}
  return (
    <Create title={'Create App Constant'}>
        <Grid
            container
            columns={1}
            rowSpacing={2}
            style={{padding: "12px 12px 12px 12px"}}
        >
            <Grid item xs={4}>
                <TextField
                    label="Name"
                    id="name"
                    value={name}
                    onChange={(event: any) => setName(event.target.value)}
                />
                </Grid>
                <Grid item xs={4}>
                    <TextField
                        label="Value"
                        id="value"
                        value={value}
                        onChange={(event: any) => setValue(event.target.value)}
                    />
                </Grid>
                <Grid item xs={4}>
                    <Button onClick={handleSave} variant="contained">
                        {'Save'}
                    </Button>
                </Grid>
            
        </Grid>
    </Create>
  )
}

export default CreateAppConstant
